import { Schema } from "effect";
import { WorkflowInstanceTarget, type WorkflowDefinitionRecord, type WorkflowStepRecord } from "../../api/workflows/model.ts";
import { restartFromStepParam } from "./workflow-format.ts";

/** The clicked definition remains the captured context for the create dialog
 * and its accepted completion; it is not a replacement catalog or query owner. */
export interface WorkflowStartIntent {
  readonly workspaceId: string;
  readonly definition: WorkflowDefinitionRecord;
  readonly className: string;
  readonly expectedWorkerId: string;
}
export const workflowStartIntent = (workspaceId: string, definition: WorkflowDefinitionRecord): WorkflowStartIntent => ({ workspaceId, definition, className: definition.className, expectedWorkerId: definition.routing.workerId });
export const WorkflowRestartIntent = Schema.Struct({
  selectionKey: Schema.String,
  target: WorkflowInstanceTarget,
  from: Schema.Struct({ name: Schema.String, count: Schema.Number, type: Schema.Literals(["do", "sleep", "waitForEvent"]) })
});
export type WorkflowRestartIntent = typeof WorkflowRestartIntent.Type;
export const workflowRestartIntent = (selectionKey: string, target: typeof WorkflowInstanceTarget.Type, step: WorkflowStepRecord): WorkflowRestartIntent => ({ selectionKey, target: { workspaceId: target.workspaceId, instanceId: target.instanceId }, from: restartFromStepParam(step) });
